import { css } from '@emotion/react';
import { IntegrationsQueries } from '@frontend/api-integrations';
import { shell } from '@frontend/shell-utils';
import { ExternalLinkIcon, useAlert } from '@frontend/design-system';

export const PmsButton = ({
  personPMId,
  sourceId,
  locationId,
}: {
  personPMId: string;
  locationId: string;
  sourceId: string;
}) => {
  const { isWindows } = shell;
  const alert = useAlert();

  const { pmsName, isClickToOpenSupported, isLoading } = IntegrationsQueries.useIsClickToOpenSupported({
    locationId: locationId,
    sourceId: sourceId,
  });

  const openPms = async () => {
    switch (pmsName) {
      case 'dentrixg5':
        openDentrix();
        break;
      default:
        alert.error('Unable to open the PMS.');
        break;
    }
  };

  const openDentrix = async () => {
    if (isWindows) {
      try {
        await shell.invoke?.('dentrix:open:patientfile', {
          patientId: personPMId,
        });
      } catch (err) {
        alert.error('Unable to open Dentrix.');
      }
    } else {
      alert.error(
        'Oops! This action is only supported when using our desktop application on a Windows operating system.'
      );
    }
  };

  if (!pmsName || !isClickToOpenSupported || isLoading || pmsName === '' || !personPMId || personPMId === '') {
    return null;
  }

  return (
    <ExternalLinkIcon
      data-trackingid='contact-panel-btn-open-pms'
      size={16}
      css={css`
        display: inline-block;
        padding: 0;
        margin-left: 8px;
        cursor: pointer;
        margin-bottom: 0px;
      `}
      onClick={openPms}
    />
  );
};
